import React from 'react';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {
  hasOptimizationFeatureFlag as hasOptimizationFeatureFlagSelector,
  hasTrussDesignPermission as hasTrussDesignPermissionSelector,
} from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { getActiveComponentDesign } from '../../../store/selectors/getActiveComponentDesignSelector';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { inViewOnlyMode } from '../../../store/selectors/viewOnlyModeSelectors';
import { setOptimizationPanelClosed, setOptimizationPanelOpen } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function OptimizationButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const hasOptimizationFeatureFlag = useAppSelector(hasOptimizationFeatureFlagSelector);
  const hasTrussDesignPermission = useAppSelector(hasTrussDesignPermissionSelector);
  const inLayoutMode = useAppSelector(isLayoutViewActive);
  const componentIsViewOnly = useAppSelector(inViewOnlyMode);
  const activeComponentDesign = useAppSelector(getActiveComponentDesign);
  const open = useAppSelector((state) => state.panelData.optimizationPanelOpen);

  if (!hasOptimizationFeatureFlag || inLayoutMode || !hasTrussDesignPermission) return null;

  return (
    <ToolbarIconButton
      title="Optimization"
      icon={<AutoFixHighIcon />}
      onClick={() => {
        dispatch(open ? setOptimizationPanelClosed() : setOptimizationPanelOpen());
        monitor.recordInteraction(open ? 'Optimization Panel Closed' : 'Optimization Panel Opened');
      }}
      disabled={activeComponentDesign == null || componentIsViewOnly}
    />
  );
}
